import { PIN_POOL_FORM } from '../form-cardgroup-types';
import { showToast } from '../../../toasts';

import useAuth from '../../../../hooks/auth-hooks';
import PostPinPool from '../../../../routes/post-pin-pool';

/**
 * Updates the pin pool for a card group and calls the function to send teh data
 * to the server.
 * 
 * @returns void
 */
export const updatePinPool = () => {
  const ppForm = PIN_POOL_FORM.ppForm;
  const ppActive = PIN_POOL_FORM.ppActive;
  const ppFieldContainer = PIN_POOL_FORM.ppFieldContainer;
  const ppSubmitButton = PIN_POOL_FORM.ppSubmitButton;
  const ppCardGroupName = PIN_POOL_FORM.ppCardGroupName;

  ppForm.addEventListener('submit', async event => {
    let hasPin: boolean = true;
    let pinCount = ppFieldContainer.children.length;

    if ( ppActive.checked && pinCount === 0 ) {
      hasPin = false;
    }
    
    if ( ppForm.checkValidity() && hasPin ) {
      event.preventDefault();
      ppForm.classList.remove('was-validated');
      ppForm.classList.remove('form-control:valid');
      ppSubmitButton.classList.add('aafp_button-loading');

      let getPin = document.querySelectorAll<HTMLElement>('[data-pin-number]');
      let cardGroupId = ppCardGroupName.getAttribute('data-card-group-id')!;
      let pinData: string = '';
      let pinValues: Set<string> = new Set();
      let duplicatePin: boolean = false;

      // TODO: add ~ at the end of the pin number
      // TODO: pinValue throws an error - null find out why.
      getPin.forEach(pin => {
        let pinValue = pin.querySelector('[data-pin]') as HTMLInputElement;
        let pinDesc = pin.querySelector('.pin-desc') as HTMLInputElement;
        let pinValueText = pinValue.value.trim();

        if ( pinValues.has(pinValueText) ) {
          duplicatePin = true;
          showToast('aafp_toast-alert', `Duplicate pin number found: ${pinValueText}`);
          return;
        }

        pinValues.add(pinValueText);
        pinData += `${pinValueText}|${pinDesc.value === '' ? null : pinDesc.value},`;
      });

      if ( duplicatePin ) {
        ppSubmitButton.classList.remove('aafp_button-loading');
        return;
      }

      const { userId } = useAuth()!;

      const awsJsonData = {
        wpId: userId,
        cardGroupId: +cardGroupId,
        pinPoolFlag: ppActive.checked ? 1: 0,
        pins: pinData.slice(0, -1)
      };

      const { statusCode } = await PostPinPool(awsJsonData);
      if ( statusCode === 200 ) {
        showToast('aafp_toast', `Pin Pool has been updated`);
        setTimeout(() => {
          location.href = `/card-group/edit-card-group/?groupAction=edit&groupID=${cardGroupId}`;
        }, 2000);
      }
    } else {
      event.preventDefault();
      event.stopPropagation();
      ppForm.classList.add('was-validated');
      if (pinCount === 0) {
        showToast('aafp_toast-alert', `Please add at least one pin number`);
      }
    }
  });
};